let subscriptionToggle = {
    init: function(){
        this.showOrHideToggle();
        this.toggleWidgetSync();
        this.syncBothToggles();
        this.handleSubscriptionOffDefault();
    },
    handleSubscriptionOffDefault: function(){
        const wrapper = document.querySelector('.product-subscription-type-wrapper[data-subscription-off-default="true"]');
        if (wrapper) {
            const toggle = document.getElementById('subToggle');
            const toggle2 = document.getElementById('subToggle2');
            if (toggle) toggle.checked = false;
            if (toggle2) toggle2.checked = false;
            this.applyRechargeClick('onetime');
            this.updateBadges('onetime');
        }
    },
    onElementReady: function(selector, callback, timeout = 10000) {
        const el = document.querySelector(selector);
        if (el) {
            callback(el);
            return;
        }

        let fired = false; // ← guard: prevent double-firing from queued mutation callbacks
        const observer = new MutationObserver(() => {
            const element = document.querySelector(selector);
            if (element && !fired) {
                fired = true;
                observer.disconnect();
                callback(element);
            }
        });

        observer.observe(document.body, { childList: true, subtree: true });
        setTimeout(() => observer.disconnect(), timeout);
    },
    showOrHideToggle: function(){
        const subscriptionToggles = document.querySelectorAll('.product-subscription-type-wrapper');
        const rcContainer = document.querySelector('.rc-container.rc_container');

        if(rcContainer && subscriptionToggles.length > 0) {
            let validateClass = window.getComputedStyle(rcContainer).display;
            subscriptionToggles.forEach(toggle => {
                if(validateClass == "block"){
                    toggle.classList.add("show-toggle");
                } else {
                    toggle.classList.remove("show-toggle");
                }
            });
        }
    },
    toggleWidgetSync: function(){
        const widgetSelect = document.querySelector('.rc-selling-plans__dropdown');

        if(widgetSelect){
            const selectOptions = widgetSelect.querySelectorAll('option');
            const toggleSelects = document.querySelectorAll('.subscription-dropdown .custom-select');

            toggleSelects.forEach(toggleSelect => {
                let htmlOptions = "", selected = "selected", nameOption, splitName;

                toggleSelect.innerHTML = "";
                if(selectOptions.length <= 1){
                    toggleSelect.classList.add("disabled");
                } else {
                    toggleSelect.classList.remove("disabled");
                }
                selectOptions.forEach(option => {
                    nameOption = option.dataset.planOption;
                    splitName = nameOption.split("with");
                    htmlOptions += `<div class="custom-option ${selected}" data-value="${option.value}"><i class="fa fa-check"></i>${splitName[0]}</div>`;
                    selected = "";
                });
                toggleSelect.innerHTML = htmlOptions;
            });
        }
    },
    syncBothToggles: function(){
        const toggle1 = document.getElementById('subToggle');
        const toggle2 = document.getElementById('subToggle2');

        // ← guard: prevent duplicate listeners if init() ever runs more than once
        if(toggle1 && toggle2 && !toggle1.dataset.syncBound){
            toggle1.dataset.syncBound = 'true';

            toggle2.checked = toggle1.checked;

            toggle1.addEventListener('change', function(){
                toggle2.checked = this.checked;
            });

            toggle2.addEventListener('change', function(){
                toggle1.checked = this.checked;
                toggle1.dispatchEvent(new Event('change'));
            });
        }
    },
    resetSelectToggle: function(){
        let options = document.querySelectorAll(".custom-option");
        options.forEach(option => {
            option.classList.remove("selected");
        });
        document.querySelectorAll(".subscription-dropdown .custom-select").forEach(select => {
            const firstOption = select.querySelector(".custom-option");
            if(firstOption) firstOption.classList.add("selected");
        });
    },
    changeSelectToggle: function(){
        const customOption = document.querySelectorAll(".custom-option");
        customOption.forEach(option => {
            // ← guard: prevent duplicate click listeners on repeated calls
            if(option.dataset.selectBound) return;
            option.dataset.selectBound = 'true';

            option.addEventListener('click', function(e) {
                e.preventDefault();
                const rechargeDropdown = document.querySelector('.rc-selling-plans__dropdown');
                customOption.forEach(opt => {
                    opt.classList.remove("selected");
                });
                option.classList.add("selected");
                if(rechargeDropdown){
                    rechargeDropdown.value = option.dataset.value;
                }
            });
        });
    },
    updateBadges: function(state) {
        const subBadges = document.querySelector('.subscription-badges');
        const oneTimeBadges = document.querySelector('.one-time-badges');

        if(subBadges && oneTimeBadges){
            if(state === 'subscribe'){
                subBadges.style.display = 'flex';
                oneTimeBadges.style.display = 'none';
            } else {
                subBadges.style.display = 'none';
                oneTimeBadges.style.display = 'flex';
            }
        }
        // Style 2 badges handled via CSS :checked states
    },
    applyRechargeClick: function(state) {
        const subLabel = document.querySelector('label[data-option-subsave]');
        const oneTimeLabel = document.querySelector('label[data-option-onetime]');
        const originalPrice = document.querySelector('.product-price .sub-original-price');
        const compareAtPrice = document.querySelector('.product-price .compare-at-price');

        if(!subLabel || !oneTimeLabel) return;

        if(state === 'subscribe'){
            subLabel.click();
            if(originalPrice){
                originalPrice.style.display = '';
                compareAtPrice.style.display = 'none';
            }
        } else {
            if(originalPrice){
                originalPrice.style.display = 'none';
                if(compareAtPrice !== null && compareAtPrice.textContent.trim() !== '' && compareAtPrice.textContent !== '$0'){
                    compareAtPrice.style.display = '';
                }
            }
            oneTimeLabel.click();
        }
        this.resetSelectToggle();
    }
};

document.addEventListener('DOMContentLoaded', function() {
    const toggle = document.getElementById('subToggle');
    const toggle2 = document.getElementById('subToggle2');
    const customSelects = document.querySelectorAll(".custom-select");

    subscriptionToggle.onElementReady(".rc-container.rc_container", () => {
        document.addEventListener('click', function(e) {
            customSelects.forEach(customSelect => {
                const selectTarget = customSelect.contains(e.target);
                if(selectTarget){
                    customSelect.classList.toggle("active");
                    subscriptionToggle.changeSelectToggle();
                } else {
                    customSelect.classList.remove("active");
                }
            });
        });

        // ← bumped from 200ms to 600ms to let Recharge fully settle before init
        setTimeout(() => {
            subscriptionToggle.init();
        }, 600);
    });

    function handleToggleChange(state) {
        subscriptionToggle.applyRechargeClick(state);
        subscriptionToggle.updateBadges(state);
        const stickyCompare = document.querySelector(".sticky-atc .compare-price");
        if(stickyCompare){
            stickyCompare.style.display = state === "onetime" ? "none" : "block";
        }
    }

    if(toggle){
        toggle.addEventListener('change', function() {
            handleToggleChange(this.checked ? 'subscribe' : 'onetime');
        });
    }

    if(toggle2){
        toggle2.addEventListener('change', function() {
            handleToggleChange(this.checked ? 'subscribe' : 'onetime');
        });
    }
});

/* 
 * A/B TESTING HELPER FUNCTIONS
 * ============================
 * The class "use-style-2" on body controls:
 * - Subscription widget (Style 1 vs Style 2)
 * - ATC button layout
 * - Price block visibility
 * - Description / bullets / accordion styling
 * - Mobile title positioning
 */

function enableStyle2() {
    document.body.classList.add('use-style-2');
    console.log('✅ Style 2 enabled');
}

function enableStyle1() {
    document.body.classList.remove('use-style-2');
    console.log('✅ Style 1 enabled (default)');
}

function toggleStyle() {
    document.body.classList.toggle('use-style-2');
    const current = document.body.classList.contains('use-style-2') ? 'Style 2' : 'Style 1';
    console.log(`🔄 Toggled to ${current}`);
    return current;
}

function getActiveStyle() {
    return document.body.classList.contains('use-style-2') ? 'style-2' : 'style-1';
}

// Legacy aliases
function enableSubscriptionStyle2() { enableStyle2(); }
function enableSubscriptionStyle1() { enableStyle1(); }
function getActiveSubscriptionStyle() { return getActiveStyle(); }
